import React from "react";
import { Box } from "../Box";
import { IconGridCard } from "../IconGridCard";
import { Image } from "../Image";
import { LinkButton } from "../LinkButton";
import { Text } from "../Text";
import { Title } from "../Title";
import { getIconSelector } from "../../utils/IconSelector";
import { OutagesCardProps } from ".";

// space missing from the theme the sits between t(iny) and m(edium)
const spaceSmall = 24;

export const OutagesCard: React.FC<OutagesCardProps> = ({ cards }) => {
  return (
    <>
      <IconGridCard dataTestID="OutagesCards">
        {cards.map(item => {
          return (
            <Box
              ml={[3, 3, spaceSmall, spaceSmall]}
              mb={[3, 3, spaceSmall, spaceSmall]}
              flex="1 0 50%"
              border="1px solid #BDBDBD"
              boxSizing="border-box"
            >
              <Box margin={spaceSmall} data-testid="OutageCard">
                <Image mb={3} data-testid={`OutageCard--${item.variant}`} src={getIconSelector(item.variant)} alt={item.variant} />
                <Title as="h3">{item.title}</Title>
                <Text dangerouslySetInnerHTML={{ __html: item.body }} />
                <LinkButton data-testid="OutageCard--linkButton" target="_blank" display="block" mt={spaceSmall} {...item.linkButton} />
                <Text data-testid="OutageCard--action" dangerouslySetInnerHTML={{ __html: item.action }} />
              </Box>
            </Box>
          );
        })}
      </IconGridCard>
    </>
  );
};
